var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-process-step-summary" },
    [
      _c(
        "affix",
        {
          staticStyle: { width: "250px" },
          attrs: { "relative-element-selector": "#content-primary" }
        },
        [
          _c(
            "h2",
            {
              staticClass:
                "c-process-step-summary__process-name t-margin-bottom-s"
            },
            [_vm._v("\n      " + _vm._s(_vm.processName) + "\n    ")]
          ),
          _vm._v(" "),
          _vm.processSteps.length > 0
            ? _c(
                "h2",
                {
                  staticClass: "c-process-step-summary__title t-margin-bottom-s"
                },
                [_vm._v("\n      Steg i processen\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "scroll-spy-active",
                  rawName: "v-scroll-spy-active",
                  value: {
                    selector: ".c-process-step-summary__name",
                    class: "c-process-step-summary__active"
                  },
                  expression:
                    "{\n        selector: '.c-process-step-summary__name',\n        class: 'c-process-step-summary__active'\n      }"
                },
                { name: "scroll-spy-link", rawName: "v-scroll-spy-link" }
              ],
              staticClass: "c-process-step-summary__container"
            },
            [
              _vm._l(_vm.processSteps, function(step, index) {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "scroll-to",
                          rawName: "v-scroll-to",
                          value: { el: "#step-" + step.id },
                          expression: "{ el: '#step-' + step.id }"
                        }
                      ],
                      staticClass: "c-process-step-summary__wrapper"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "c-process-step-summary__link" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "c-process-step-summary__circle",
                              class: {
                                "c-process-step-hide__circle":
                                  step.status === "Unpublished"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "c-process-step-summary-circle__numbers"
                                },
                                [_vm._v(_vm._s(step.number))]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "c-process-step-summary__name" },
                            [_vm._v(_vm._s(step.name))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.processSteps.length > 1 &&
                      index !== _vm.processSteps.length - 1
                        ? _c("span", {
                            staticClass: "c-process-step-summary__line"
                          })
                        : _vm._e()
                    ]
                  )
                ]
              })
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }